var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloseicon = function SvgCloseicon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "x-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.395,
    height: 21.395,
    viewBox: "0 0 21.395 21.395",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M10.7,20.058a9.36,9.36,0,1,0-9.36-9.36,9.36,9.36,0,0,0,9.36,9.36Zm0,1.337A10.7,10.7,0,1,0,0,10.7,10.7,10.7,0,0,0,10.7,21.395Z",
    fill: "#6b6b6b",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M4.7,4.7a.669.669,0,0,1,.947,0L9.18,8.235,12.719,4.7a.669.669,0,0,1,.947.947L10.126,9.18l3.54,3.538a.669.669,0,0,1-.947.947L9.18,10.126l-3.538,3.54a.669.669,0,1,1-.947-.947L8.235,9.18,4.7,5.642a.669.669,0,0,1,0-.947Z",
    transform: "translate(1.517 1.517)",
    fill: "#6b6b6b",
    fillRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseicon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/closeicon.d00fcec7cb2f77812ed073b9d5a3c867.svg";